import { render, staticRenderFns } from "./AssignmentTask.vue?vue&type=template&id=38347eca&scoped=true&"
import script from "./AssignmentTask.vue?vue&type=script&lang=ts&"
export * from "./AssignmentTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38347eca",
  null
  
)

export default component.exports